import { orderBy } from 'lodash';

const __baseObjectType = {
  __orderedKey: undefined,
  __getValue(v: number | null | undefined) {
    const keys = Object.keys(this);
    return keys.find(k => this[k] === v) || '';
  },
  __getKeys() {
    return Object.keys(this).filter(x => !x.startsWith('__'));
  },
  __getSelectOptions() {
    return (this.__orderedKey || orderBy(this.__getKeys(), x => x)).map(k => {
      return { label: k, value: this[k] };
    });
  },
};

export const LocationType = {
  City: 1,
  Area: 2,
  Prefecture: 3,
  IATACity: 4,
  Hotel: 5,
  ...__baseObjectType,
};

export const AgentType = {
  NtaBranch: 1,
  NtaGroupCompany: 2,
  RetailerTravelAgency: 3,
  VIPAgent: 4,
  WholesalerOperator: 5,
  ...__baseObjectType,

  __getValue(v) {
    return this.__getSelectOptions().find(x => x.value === v)?.label || v;
  },

  __getSelectOptions() {
    return [
      {
        label: 'NTA Branch',
        value: 1,
      },
      {
        label: 'NTA Group Company',
        value: 2,
      },
      {
        label: 'Retailer/TravelAgency',
        value: 3,
      },
      {
        label: 'VIP Agent',
        value: 4,
      },
      {
        label: 'Wholesaler/Operator',
        value: 5,
      },
    ];
  },
  __getAgentSelectOptions() {
    return [
      {
        label: 'NTA Branch',
        value: 1,
      },
      {
        label: 'NTA Group Company',
        value: 2,
      },
      {
        label: 'Retailer/TravelAgency',
        value: 3,
      },

      {
        label: 'Wholesaler/Operator',
        value: 5,
      },
    ];
  },
};

export const AgentRoleType = {
  Admin: 'Admin',
  Report: 'Report',
  Booking: 'Booking',
  __getRoles: ['Admin', 'Report', 'Booking'],
};

export const BoardType = {
  NoMeals: 1,
  BreakfastIncl: 3,
  DinnerOnly: 4,
  DinnerAndBreakfastIncl: 5,
  ...__baseObjectType,

  __getSelectOptions() {
    return [
      {
        label: 'No meal',
        value: 1,
      },

      {
        label: 'Breakfast included',
        value: 3,
      },
      {
        label: 'Dinner only',
        value: 4,
      },
      {
        label: 'Breakfast and dinner included',
        value: 5,
      },
    ];
  },
  __getValue(v) {
    return this.__getSelectOptions().find(x => x.value === v)?.label || v;
  },
};

export const PaymentStatus = {
  Pending: 1,
  Unx: 2,
  Authorized: 3,
  Paid: 4,
  Failed: 5,
  PartiallyRefunded: 6,
  Refunded: 7,
  Cancelled: 8,
  NeedToCheck: 9,
  ...__baseObjectType,
  __getColor(status: number | null | undefined) {
    if (status) {
      return ['white', '#919993', '#919090', '#f5aa42', '#0fbf38', '#bf081a', '#ed53c4', '#820360', '#720600', '#e7ebed'][status];
    }
    return undefined;
  },
};

export const BookingStatus = {
  Processing: 1,
  PartialBooked: 2,
  Booked: 3,
  Hold: 4,
  PartialHold: 5,
  Failed: 6,
  Cancelled: 7,
  ...__baseObjectType,
  __getColor(status: number | null | undefined) {
    if (status) {
      return ['white', '#919993', '#919090', '#0fbf38', '#8f5d07', '#f5aa42', '#bf081a', '#720600'][status];
    }
    return undefined;
  },
};

export const BookingErrorType = {
  None: 0,
  Validation: 1,
  PaymentAuthorize: 2,
  ConfirmBooking: 3,
  InternalException: 4,
  BookingProcessing: 5,
  ...__baseObjectType,
};

export const HotelRoomStatus = {
  Processing: 1,
  Booked: 2,
  Cancelled: 3,
  Failed: 4,
  ...__baseObjectType,

  __getColor(status: number | null | undefined) {
    if (status) {
      return ['white', '#919090', '#0fbf38', '#f5aa42', '#bf081a'][status];
    }
    return undefined;
  },
};
export const OrderStatus = {
  Booked: 1,
  Cancelled: 2,
  Hold: 3,
  Failed: 4,
  Processing: 5,
  'Booked*': 6,
  'Hold*': 7,

  ...__baseObjectType,

  __getColor(status: number | null | undefined) {
    if (status) {
      return ['white', '#0fbf38', '#bf081a', '#8f5d07', '#720600', '#919090', '#0fbf38', '#8f5d07'][status];
    }
    return undefined;
  },
};

export const RoomCategoryOrder = {
  Single: 1,
  Twin: 2,
  'Semi-double': 3,
  Double: 4,
  Triple: 5,
  '4 Beds': 6,
  'Japanese-style room': 7,
  'Japanese-Western mixed room': 8,
  Others: 10,
};

export const AgentCompanySize = {
  Small: 1,
  Medium: 2,
  Large: 3,
  ...__baseObjectType,

  __getSelectOptions() {
    return [
      {
        label: 'Small (1-10 employee)',
        value: 1,
      },

      {
        label: 'Medium (11-100 employee)',
        value: 2,
      },
      {
        label: 'Large (Over 101 employee)',
        value: 3,
      },
    ];
  },
};

export const BookingSource = {
  Omega: 1,
  ForAgent: 2,
  ...__baseObjectType,
};
